export default __webpack_public_path__ + "static/media/youtube.b6cb68cd.svg";